import styled from "styled-components";
import THEME from "../../assets/styles/config";
import Media from "../../assets/styles/media";

export const TableBody = styled.table`
  margin-bottom: 30px;
  width: 100%;
  > tbody {
    > tr {
      > th {
        font-weight: normal;
        font-size: 16px;
        text-align: start;
        vertical-align: top;
        width: 55%;
        color: ${THEME.colors.secondaryFontColor};
        padding-bottom: 20px;

        ${Media.Below.desktopLarge`
          font-size: 14px;
        `}
      }

      > td {
        font-size: 16px;
        padding-bottom: 20px;

        ${Media.Below.desktopLarge`
          font-size: 14px;
        `}
      }
    }
  }
`;